<template>
  <div>
    <h3 class="title mb-0">PRODUCCIÓN</h3>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-10">
          <button class="mt-5 d-block ml-auto mr-auto button-app-big w-100" type="button" @click="$router.push('/production/day')">
            Producción diaria
          </button>
        </div>
        <div class="col-10">
          <button class="mt-3 d-block ml-auto mr-auto button-app-big w-100" type="button" @click="$router.push('/production/calendar')">
            Producción por fecha
          </button>
        </div>
        <div class="col-10">
          <button class="mt-3 d-block ml-auto mr-auto button-app-big w-100" type="button" @click="$router.push('/production/month')">
            Producción mensual
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Production'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Production.vue